
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-usage-policy",
      function () {
        return require("private-next-pages/ai-usage-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-usage-policy"])
      });
    }
  